var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRastelCoin = function SvgRastelCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.534c0 5.543-4.479 10.033-10 10.033s-10-4.49-10-10.033C.5 4.99 4.979.5 10.5.5s10 4.49 10 10.034Z",
    fill: "#fff",
    stroke: "#2B0088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.036 6.727V4.74h6.14c1.531 0 2.178 1.325 2.31 1.987v3.312c0 1.43-1.188 1.965-1.783 2.053l2.047 4.503h-2.575l-1.914-4.503H9.412v4.503H7.036v-4.503h-2.31v-2.053h2.31V8.913h-2.31V6.727h2.31Z",
    fill: "#2B0088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.214 9.64V6.728h3.103c.476 0 .594.353.594.53.022.552.04 1.722-.066 1.987a.676.676 0 0 1-.462.397H9.214Z",
    fill: "#fff"
  })));
};
export default SvgRastelCoin;